module.exports = __webpack_public_path__ + "img/p.623ffbc0.jpg";